import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { UserProfileService } from 'src/app/core/http/user-profile.service';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  environment = environment;
  userInfo;
  displayProfile;
  @Input() showHeaderContent;
  currentUser$;
  loggedInUserName: string;

  private subscriptions = new Subscription();
  
  constructor(private authenticationService: AuthenticationService,
    private userProfileService: UserProfileService,) 
    {
      
    }

  ngOnInit(): void {
    this.currentUser$ = this.userProfileService.currentUser;
    const msalBroadcast$ =
      this.authenticationService.msalBroadcastComplete$.subscribe(() => {
        this.loggedInUserName = this.authenticationService.getUserName();
        this.userInfo =  this.authenticationService.getADUserProfile();
      });
    this.subscriptions.add(msalBroadcast$);
  }

  logOut() {
    this.authenticationService.logOut();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
